import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: (resolve) => require(['@/components/home/Home'], resolve),
      meta: {
        // 添加该字段，表示进入这个路由是需要登录的
        requireAuth: true
      },
      children: [
        {path: '/Home/School', name: '院校数据', component: resolve => require(['@/components/component/School/School'], resolve)},
        {path: '/Home/Major', name: '专业数据', component: resolve => require(['@/components/component/Major/Major'], resolve)},
        {path: '/Home/Matrix', name: '矩阵', component: resolve => require(['@/components/component/Matrix/Matrix'], resolve)},
        {path: '/Home/Form', name: '表单', component: resolve => require(['@/components/component/from/From'], resolve)},
        {path: '/Home/Table', name: '表格', component: resolve => require(['@/components/component/table/Table'], resolve)},
        {path: '/Home/SensitiveWords', name: '敏感词', component: resolve => require(['@/components/component/SensitiveWords/SensitiveWords'], resolve)},
        {path: '/Home/HotWords', name: '热词', component: resolve => require(['@/components/component/HotWords/HotWords'], resolve)},
        {path: '/Home/Remarks', name: '备注名管理', component: resolve => require(['@/components/component/Remarks/Remarks'], resolve)},
        {path: '/Home/GroupDynamic', name: '群动态管理', component: resolve => require(['@/components/component/GroupDynamic/GroupDynamic'], resolve)},
        {path: '/Home/NotificationList', name: '通知列表', component: resolve => require(['@/components/component/Notification/NotificationList/NotificationList'], resolve)},
        {path: '/Home/NotificationInfo', name: '通知详情', component: resolve => require(['@/components/component/Notification/NotificationInfo/NotificationInfo'], resolve)},
        {path: '/Home/Dashboard', name: '数据展示', component: (resolve) => require(['@/components/component/dashboard/Dashboard'], resolve)},
        {path: '/Home/GroupVideo', name: '群视频预警', component: (resolve) => require(['@/components/component/GroupVideo/GroupVideo'], resolve)},
        {path: '/Home/InactionAccounts', name: '不活跃的账号', component: (resolve) => require(['@/components/component/InactionAccounts/InactionAccounts'], resolve)}
      ]
    },
    {
      path: '/Login',
      name: 'Login',
      component: (resolve) => require(['@/components/login/Login'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js